import * as React from 'react';
import { useSelector } from 'react-redux';
import { debounce } from 'throttle-debounce';

import { useAuthErrorTitle } from 'shared/components/OfferHistory/containers/utils/useAuthErrorTitle';
import { useDeactivatedLabelTitle } from 'shared/components/OfferHistory/containers/utils/useDeactivatedLabelTitle';

import {
  trackOfferFromHistoryGalleryClick,
  trackOfferFromHistoryGalleryScroll,
  trackOfferFromHistoryShow,
  trackRedirectToOfferClick,
} from './analytics';
import { useHandleResolveAuthError } from './utils/useHandleResolveAuthError';
import {
  selectOfferFromHistory,
  selectIsOfferFromListingLoading,
  selectIsOfferFromListingError,
  selectIsOfferFromListingAuthError,
} from '../../../selectors/offersHistory';
import { OfferFromHistory } from '../components';

export const OfferFromHistoryContainer: React.FC = () => {
  const isLoading = useSelector(selectIsOfferFromListingLoading);
  const isError = useSelector(selectIsOfferFromListingError);
  const isAuthError = useSelector(selectIsOfferFromListingAuthError);
  const offerFromHistory = useSelector(selectOfferFromHistory);

  const trackGalleryScrollDebounced = React.useMemo(() => debounce(150, trackOfferFromHistoryGalleryScroll), []);

  const deactivatedTitle = useDeactivatedLabelTitle();
  const authErrorTitle = useAuthErrorTitle();
  const handleResolveAuthError = useHandleResolveAuthError();

  return (
    <OfferFromHistory
      offer={offerFromHistory}
      isLoading={isLoading}
      isError={isError}
      isAuthError={isAuthError}
      deactivatedTitle={deactivatedTitle}
      authErrorTitle={authErrorTitle}
      onOfferShow={trackOfferFromHistoryShow}
      onGalleryScroll={trackGalleryScrollDebounced}
      onGalleryClick={trackOfferFromHistoryGalleryClick}
      onRedirectToOfferClick={trackRedirectToOfferClick}
      onAuthErrorClick={handleResolveAuthError}
    />
  );
};
